export default __webpack_public_path__ + "place-ring-fill.9db1fc6462722c0f.svg";